import React from 'react';

const Skill = ( ) => {
    return (
        <div className="rn-about-area rn-section-gap line-separator" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title">
                            <h3 className="title">My experiences during passed years</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="experience_inner">
                            <div className="single-list">
                                <div className="list_inner">
                                    <p><span>April, 2019 - Today</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Head Designer & Co-founder</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Bona Green Design, London</span></p>
                                </div>
                            </div>
                            
                            <div className="single-list">
                                <div className="list_inner">
                                    <p><span>September, 2018 - April, 2019</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Creative Director & Senior Designer</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Bona Green Design, London</span></p>
                                </div>
                            </div>
                            
                            <div className="single-list">
                                <div className="list_inner">
                                    <p><span>October, 2015 - September, 2018</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Head Designer</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Arimana Co. Ltd, Amsterdam</span></p>
                                </div>
                            </div>
                            <div className="single-list">
                                <div className="list_inner">
                                    <p><span>April, 2019 - Today</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Senior UX & UI Designer</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Arimana Co. Ltd, Amsterdam</span></p>
                                </div>
                            </div>

                            <div className="single-list">
                                <div className="list_inner">
                                    <p><span>March, 2010 - July, 2012</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Junior UX Designer</span></p>
                                </div>
                                <div className="list_inner">
                                    <p><span>Simono Design Group, London</span></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skill;
